import $ from "jquery";

import "./make_acquiror_fields_required_or_optional";
import "./wd_transactions_form_customization";
import "./collapsible_form_sections";

// If we insert a bootstrap panel, the id used to toggle it is going to always be the same, as it uses a string template
//    generated on the server.
//    We need to randomize the id after the template is inserted into the page.
$(document).on("cocoon:after-insert", function (e, insertedItem) {
  const $insertedItem = $(insertedItem);
  // a.panel-toggle
  //   href - prepend #
  //   aria-controls
  // .panel-body
  //   id

  const $panelToggle = $insertedItem.find(".panel-toggle");
  const $panelBody = $insertedItem.find(".panel-body");

  const newID = `id-${Math.random().toString(36).substring(2, 15)}`;

  $panelToggle.attr("href", `#${newID}`);
  $panelToggle.attr("aria-controls", newID);
  $panelBody.attr("id", newID);
});

$(document).on("cocoon:after-remove", ".admin-form:not(.disabled)", function(e, removedNode) {
  if ($(removedNode.context).hasClass("dynamic")) {
    // Removed an unpersisted nested-record fields node. Do nothing.
  } else {
    removedNode.show();
    removedNode
      .addClass("marked-for-destruction")
      .children(".panel-default")
      .removeClass("panel-default")
      .addClass("panel-danger");
  }
});

// Allow admins to revert deletion of a record before submitting the form or when editting a pending form.
$(document).on("click", ".admin-form:not(.disabled) .undo-remove-association-link a", function(e) {
  var $undoLink = $(this);
  var $removedNode = $undoLink.closest(".nested-fields");

  $removedNode
    .removeClass("marked-for-destruction")
    .children(".panel-danger")
    .removeClass("panel-danger")
    .addClass("panel-default");
  $undoLink.closest(".cocoon-remove-undo-links").find("input[type=hidden]").val("");

  e.stopPropagation();
  e.preventDefault();
});

const buttonizeIndustrialSectorCheckboxes = function () {
  $(".checkboxes-show-only-icons .simple-form-check-radio-flex-wrapper > .checkbox").each(function () {
    const $this = $(this);
    const $input = $this.find("input");
    const checkGrayScale = function () {
      const checked = $input[0].checked;

      if (checked) {
        $this.removeClass("grayscale-checkbox");
      } else {
        $this.addClass("grayscale-checkbox");
      }
    };

    $this.click(checkGrayScale);
    checkGrayScale();
  });
};

const initExpertiseTagBox = function () {
  const $boxWrapper = $(".expertise-tag-box");
  const $innerPannelWrapper = $boxWrapper.find(".tag-inner-panel-wrapper");
  const $innerPannels = $innerPannelWrapper.find(".expertise-tag-inner-panel");

  // :not(.tag-toggle-bound) keeps this idempotent -- whatever re-runs turbolinks:load handlers
  // against a DOM that already has these buttons (e.g. a cached/restored page) would otherwise
  // append a second <a class="toggle-inner-tags"><i class="fa fa-caret-right"> into the same
  // checkbox span every time, rendering two arrows side by side (QA, 2026-08-29).
  const $checkboxes = $(".section_organisation_type .simple-form-check-radio-flex-wrapper > .checkbox:not(.tag-toggle-bound)");

  $checkboxes.each((i, span) => {
    const $this = $(span).addClass("tag-toggle-bound");

    const $input = $this.find("input");
    const activityId = $input.val();

    const btn = `
      <a data-activity-id=${activityId} href="#" class="toggle-inner-tags btn btn-${i === 0 ? "primary active" : "default"}"><i class="fa fa-caret-right"></i></a>
    `;
    $this.append(btn);
    const $btn = $this.find(".toggle-inner-tags");

    $btn.click((e) => {
      e.preventDefault();
      e.stopPropagation();

      const $target = $(e.target).closest("a");

      $innerPannels.removeClass("active").addClass("hidden");

      $innerPannels.filter(`.activity-${activityId}`).removeClass("hidden").addClass("active");

      $checkboxes.find(".toggle-inner-tags").removeClass("btn-primary active").addClass("btn-default");
      $target.removeClass("btn-default").addClass("btn-primary active");
    });

    $input.change(() => {
      if ($input.is(":checked")) {
        $btn.click();
      }
    });
  });
};

// show if a section has diff-status changes
$(document).on("turbolinks:load", function() {
  const diffStatuses = ["added", "changed", "deleted"];

  diffStatuses.map(function(status) {
    const exclamationHtml = `<i class="fa fa-exclamation diff-icon-${status}"></i>`;
    const $section = $(`.diff-status-${status}`).closest(".card-section");
    const $sectionHeading = $section.find("h2, h3");
    $sectionHeading.append(exclamationHtml);

    $section.map(function() {
      const $sectionId = $(this).attr("data-section-id");
      const $menuItem = $(`.section-title[data-section-title-id="${$sectionId}"`);
      $menuItem.append(exclamationHtml);
    });
  });

  buttonizeIndustrialSectorCheckboxes();

  initExpertiseTagBox();
});

// show if a section has diff-status changes
$(document).on("turbolinks:load", function() {
  $(".assign-to-quick-buttons a").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);

    if ($this.attr("disabled")) {
      return;
    }

    const $userAssignSelect2 = $this.closest(".versioned-record-assign-box").find("#card_form_versioned_record_assigned_user_id").select2();

    $userAssignSelect2.val($this.data().id);
    $userAssignSelect2.trigger("change");
  });
});
